import glowSm from '../assets/glow_sm.svg';
import supercoin from '../assets/supercoin.png';

/* Soft blurred ellipse that sits behind the hero art inside a card. */
export function GlowSm() {
  return <img className="bbd-glow-sm" src={glowSm} alt="" />;
}

/* Light-streak decoration. Position / rotation come from the modifier class. */
export function Bolt({ className, src }) {
  return (
    <div className={'bbd-bolt ' + className}>
      <div className="bbd-bolt-in">
        <img src={src} alt="" />
      </div>
    </div>
  );
}

/* The coin is cropped out of the SuperCoin lockup, exactly as in the design. */
export function Coin({ className }) {
  return (
    <div className={'bbd-coin ' + className}>
      <div className="bbd-coin-in">
        <img src={supercoin} alt="" />
      </div>
    </div>
  );
}
